import { api } from './api';

export const shippingService = {
  // Retorna { cep, region, totalWeight, totalQty, services: [{ provider, name, price, etaDays }] }
  quote: async ({ cep, items }) => {
    return api.post('/api/shipping/quote', { cep, items });
  }
};

export default shippingService;
